<template>
  <svg id="bigben" data-name="Calque 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 82.56 428.09">   
    <g id="Calque_1-2" data-name="Calque 1">
      <g>
        <path class="cls-6" d="M5,144.82h72.56v280.66c0,1.43-1.16,2.6-2.6,2.6H7.6c-1.43,0-2.6-1.16-2.6-2.6V144.82h0Z"/>
        <path class="cls-4" d="M14.03,149.4c-1.58,0-2.85,2.66-2.85,5.93v18.73h5.7v-18.73c0-3.28-1.28-5.93-2.85-5.93Z"/>
        <path class="cls-4" d="M68.85,149.4c-1.58,0-2.85,2.66-2.85,5.93v18.73h5.7v-18.73c0-3.28-1.28-5.93-2.85-5.93Z"/>
        <path class="cls-4" d="M59.71,149.4c-1.58,0-2.85,2.66-2.85,5.93v18.73h5.7v-18.73c0-3.28-1.28-5.93-2.85-5.93Z"/>
        <path class="cls-4" d="M50.58,149.4c-1.58,0-2.85,2.66-2.85,5.93v18.73h5.7v-18.73c0-3.28-1.28-5.93-2.85-5.93Z"/>
        <path class="cls-4" d="M41.44,149.4c-1.58,0-2.85,2.66-2.85,5.93v18.73h5.7v-18.73c0-3.28-1.28-5.93-2.85-5.93Z"/>
        <path class="cls-4" d="M32.3,149.4c-1.58,0-2.85,2.66-2.85,5.93v18.73h5.7v-18.73c0-3.28-1.28-5.93-2.85-5.93Z"/>
        <path class="cls-4" d="M23.17,149.4c-1.58,0-2.85,2.66-2.85,5.93v18.73h5.7v-18.73c0-3.28-1.28-5.93-2.85-5.93Z"/>
        <rect class="cls-5" y="163.24" width="82.56" height="80.01" rx="2.6" ry="2.6"/>
        <rect class="cls-7" x="11.18" y="172.99" width="60.52" height="60.52" rx="2.6" ry="2.6"/>
        <rect class="cls-3" x="15.23" y="177.04" width="52.42" height="52.42" rx="2.6" ry="2.6"/>
        <polygon class="cls-5" points="59.56 106.69 23 106.69 5 144.82 77.56 144.82 59.56 106.69"/>
        <rect class="cls-6" x="23" y="79.42" width="36.51" height="27.27"/>
        <path class="cls-5" d="M42.62,22.01h-2.73c-1.11,0-2.08.75-2.37,1.83l-14.52,55.59h36.51l-14.52-55.59c-.28-1.08-1.25-1.83-2.37-1.83Z"/>
        <circle class="cls-3" cx="41.44" cy="203.25" r="26.21"/>
        <circle class="cls-3" cx="41.22" cy="203.25" r="13.2"/>
        <line class="cls-2 aiguille1" x1="41.22" y1="203.25" x2="41.22" y2="211.91"/>
        <line class="cls-2 aiguille2" x1="57.84" y1="189.14" x2="41.22" y2="203.25"/>
        <path class="cls-4" d="M14.03,283.72c-1.58,0-2.85,2.66-2.85,4.32v140.05h5.7v-140.05c0-1.67-1.28-4.32-2.85-4.32Z"/>
        <path class="cls-4" d="M68.85,283.72c-1.58,0-2.85,2.66-2.85,4.32v140.05h5.7v-140.05c0-1.67-1.28-4.32-2.85-4.32Z"/>
        <path class="cls-4" d="M59.71,283.72c-1.58,0-2.85,2.66-2.85,4.32v140.05h5.7v-140.05c0-1.67-1.28-4.32-2.85-4.32Z"/>
        <path class="cls-4" d="M50.58,283.72c-1.58,0-2.85,2.66-2.85,4.32v140.05h5.7v-140.05c0-1.67-1.28-4.32-2.85-4.32Z"/>
        <path class="cls-4" d="M41.44,283.72c-1.58,0-2.85,2.66-2.85,4.32v140.05h5.7v-140.05c0-1.67-1.28-4.32-2.85-4.32Z"/>
        <path class="cls-4" d="M32.3,283.72c-1.58,0-2.85,2.66-2.85,4.32v140.05h5.7v-140.05c0-1.67-1.28-4.32-2.85-4.32Z"/>
        <path class="cls-4" d="M23.17,283.72c-1.58,0-2.85,2.66-2.85,4.32v140.05h5.7v-140.05c0-1.67-1.28-4.32-2.85-4.32Z"/>
        <path class="cls-4" d="M14.03,249.49c-1.58,0-2.85,2.66-2.85,5.93v18.73h5.7v-18.73c0-3.28-1.28-5.93-2.85-5.93Z"/>
        <path class="cls-4" d="M68.85,249.49c-1.58,0-2.85,2.66-2.85,5.93v18.73h5.7v-18.73c0-3.28-1.28-5.93-2.85-5.93Z"/>
        <path class="cls-4" d="M59.71,249.49c-1.58,0-2.85,2.66-2.85,5.93v18.73h5.7v-18.73c0-3.28-1.28-5.93-2.85-5.93Z"/>
        <path class="cls-4" d="M50.58,249.49c-1.58,0-2.85,2.66-2.85,5.93v18.73h5.7v-18.73c0-3.28-1.28-5.93-2.85-5.93Z"/>
        <path class="cls-4" d="M41.44,249.49c-1.58,0-2.85,2.66-2.85,5.93v18.73h5.7v-18.73c0-3.28-1.28-5.93-2.85-5.93Z"/>
        <path class="cls-4" d="M32.3,249.49c-1.58,0-2.85,2.66-2.85,5.93v18.73h5.7v-18.73c0-3.28-1.28-5.93-2.85-5.93Z"/>
        <path class="cls-4" d="M23.17,249.49c-1.58,0-2.85,2.66-2.85,5.93v18.73h5.7v-18.73c0-3.28-1.28-5.93-2.85-5.93Z"/>
        <line class="cls-1" x1="6" y1="144.82" x2="6" y2="112.57"/>
        <line class="cls-1" x1="76.58" y1="144.82" x2="76.58" y2="112.57"/>
        <line class="cls-1" x1="41.44" y1="33.26" x2="41.44" y2="1"/>
        <line class="cls-1" x1="24.04" y1="87.29" x2="24.04" y2="55.04"/>
        <line class="cls-1" x1="58.46" y1="87.29" x2="58.46" y2="55.04"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'profile'
}
</script>


// WEBPACK FOOTER //
// src/components/rides/peterPan/bigben.vue